import { Flex, Link, Menu, MenuButton, MenuItem, MenuList, Stack, Text } from '@chakra-ui/react'
import React, { ReactNode, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useCustomTranslation from '../../hooks/useCustomTranslation.tsx'
import { AppDrawer } from '../common/AppDrawer.tsx'

interface Option {
  value: string
  label: string
  content: ReactNode
  headingPopup?: string
}

export default function SelectMenuPopup({ options, icon }: { options: Option[]; icon: any }) {
  const { t } = useCustomTranslation()
  const [popup, setPopup] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const [content, setContent] = useState<ReactNode>()
  const openPopup = (popupName: string) => {
    setPopup(popupName)
  }

  const closePopup = () => {
    setPopup('')
    const queryParams = new URLSearchParams(location.search)
    queryParams.delete('param')
    navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true })
  }
  return (
    <Stack>
      <Menu>
        <MenuButton
          role="button"
          aria-expanded="false"
          aria-haspopup="menu"
          aria-controls="menu-list-:rc:"
          mt={2}
          _active={{ background: 'none' }}
          background="none"
          _hover={{ background: 'none' }}
          as={Link}
          defaultValue="option1"
          alignItems="center"
        >
          {icon}
        </MenuButton>
        <MenuList minWidth="10%" backgroundColor="white" left="-50px" transform="translateX(-50%)">
          {options.map((option: Option) => (
            <MenuItem
              fontSize={14}
              backgroundColor="white"
              color="white"
              key={option.value}
              onClick={() => {
                openPopup(option.value)
                setContent(option.content)

                const searchParams = new URLSearchParams(location.search)
                searchParams.set('param', option.value)
                navigate(`?${searchParams.toString()}`, { replace: true })
              }}
            >
              <Flex alignItems="center" gap={2}>
                <Text color="#333">{t(`menu.${option.label}`)}</Text>
              </Flex>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Stack>
        {options.map((option: Option) => (
          <AppDrawer
            key={option.value}
            title={option.headingPopup ? t(`menu.${option.headingPopup}`) : undefined}
            isOpen={option.value === popup}
            onClose={closePopup}
            overlay={true}
          >
            {content}
          </AppDrawer>
        ))}
      </Stack>
    </Stack>
  )
}
